import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";



const PhpLesson12 = () => {
    const [language, changeLanguage] = useState("php");
    const [lineNumbers, toggleLineNumbers] = useState(false);
      const code = (
        'text',
        `
        <?php
          $color = 'red';

          switch ($color) {
            case 'red';
            echo 'The color is red';
            break;
            case 'blue';
            echo 'The color is blue';
            break;
            case 'green';
            echo 'The color is green';
            break;
            default;
            echo 'The color is not red, blue, or green';
            break;
          }
        ?>

        `
      );







  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">
    <h3><strong>Loops</strong></h3>
    <p>A switch statement in PHP allows you to choose between several different options based on the value of an expression. Here's an example of how to use a switch statement in PHP:</p>
    <CopyBlock
    language={"php"}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />

   <p>In this example, the expression being evaluated is <b>$color</b>, which is set to <b>'red'</b>. </p>
   <p>The switch statement will look for a case that matches the value of <b>`$color`</b> and execute the code associated with that case. In this case, the code associated with the <b>'red'</b> case will be executed, which is echo <b>'The color is red';</b>.</p>
   <p>The <b>`break`</b> statement is used to exit the switch statement once the matching case has been found and executed. The <b>`default`</b> case is used to specify a block of code to be executed if no other cases match the value of the expression.</p>
   </div>
    
    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default PhpLesson12
